/**
 * Página de Notas Fiscais (NFS-e)
 */

import { FileText, Download } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/shared/PageHeader';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { toast } from 'sonner';

const mockNfse = [
  { id: 'nf-001', number: '2025-0001', status: 'emitida', amount: 499, created_at: '2025-01-15', invoice_id: 'inv-001' },
  { id: 'nf-002', number: '2025-0002', status: 'emitida', amount: 499, created_at: '2025-02-15', invoice_id: 'inv-002' },
  { id: 'nf-003', number: null, status: 'pendente', amount: 499, created_at: '2025-03-01', invoice_id: 'inv-003' },
];

export default function NfsePage() {
  return (
    <div>
      <PageHeader title="Notas Fiscais" description="NFS-e emitidas e pendentes" />

      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Número</TableHead>
              <TableHead>Valor</TableHead>
              <TableHead>Emissão</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {mockNfse.map(nf => (
              <TableRow key={nf.id}>
                <TableCell className="text-sm font-medium">{nf.number || '—'}</TableCell>
                <TableCell className="text-sm">R$ {nf.amount.toFixed(2)}</TableCell>
                <TableCell className="text-sm">{new Date(nf.created_at).toLocaleDateString('pt-BR')}</TableCell>
                <TableCell><StatusBadge status={nf.status} /></TableCell>
                <TableCell className="text-right">
                  {nf.status === 'emitida' && (
                    <div className="flex gap-1 justify-end">
                      <Button variant="ghost" size="sm" className="text-xs" onClick={() => toast.info('Download XML (placeholder)')}>XML</Button>
                      <Button variant="ghost" size="sm" className="text-xs" onClick={() => toast.info('Download PDF (placeholder)')}>
                        <Download className="h-3 w-3" />
                      </Button>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
